define('viewModels/privileged/qm/CalibrationResultsView',[
    'lib/lodash4',
    'lib/knockout',
    'lib/bluebird',
    'moment',
    'services/loggingService',
    'services/qualityManagementService',
    'services/toastService',
    'services/qm/qualityAuth',
    'services/authService',
    'util/errorCallbackFactory',
    'viewModels/ViewModel',
    'viewModels/privileged/qm/EditCalibrationView',
    'models/qm/Calibration',

    // No reference needed
    'extensions/i18n/knockout.i18n'
], function (_,
             ko,
             Promise,
             moment,
             loggingService,
             qualityManagementService,
             toasts,
             qualityAuthorization,
             authService,
             errorCallbackFactory,
             ViewModel,
             EditCalibrationView,
             Calibration
    ) {
    'use strict';

    var EMPTYSCORE = " - ";

    var CalibrationResultsView = ViewModel.extend(function (calibrationId, deleteCalibrationCallback) {
        var self = this;

        var evaluationHref;

        self.isLoading = ko.observable(true);
        self.calibrationResultsGrid = ko.observableArray();
        self.evaluationFormName = ko.observable();
        self.calibration = ko.observable();
        self.editCalibrationView = ko.observable();
        self.highScore = ko.observable();
        self.lowScore = ko.observable();
        self.averageScore = ko.observable();
        self.variance = ko.observable();
        self.canDeleteCalibration = qualityAuthorization.canDeleteCalibration();

        var submitCalibration = function (options) {
            var calibrationUpdate = self.editCalibrationView().getCalibration();
            var responseValidator = self.editCalibrationView().getResponseValidator();
            if (calibrationUpdate) {
                self.isLoading(true);
                qualityManagementService.putCalibration(calibrationUpdate)
                .then(function (response) {
                    responseValidator.handleSuccess();
                    self.calibration(new Calibration(response));
                    if (options && options.success) {
                        options.success();
                    }
                })
                .catch(responseValidator.createErrorCallback({namespace: "calibrationResults.updateCalibrationRequest"}))
                .finally(function () {
                    self.isLoading(false);
                });
            }
        };

        self.isEditing = ko.observable(false);
        self.subscribe(self.isEditing, function (newValue) {
            if (newValue) {
                self.editCalibrationView().reset();
            }
        });

        self.applyClick = function () {
            submitCalibration({
                success: function () {
                    self.isEditing(false);
                }
            });
        };

        self.deleteCalibration = function() {
            var unwrapped = ko.unwrap(self.calibration);
            deleteCalibrationCallback(unwrapped.id);
        };

        self.isCalibrationTooOldToDelete = ko.computed(function(){
            return self.calibration() && self.calibration().evaluations &&
                    _.some(self.calibration().evaluations(), function(evaluation){
                        return evaluation.createdDate && 
                            moment(ko.unwrap(evaluation.createdDate)).isBefore(moment().subtract(90, 'days'));
                    });
        });

        var aggregateEvaluationData = function (evaluationForm, scoreRows, evaluation, evaluatorId) {
            scoreRows['evaluation-total'][evaluatorId] = {
                score: EMPTYSCORE,
                comments: ''
            };
            scoreRows['evaluation-total'].style = 'evaluation-total-score-row';

            /* -- Get evaluation comments if it exists -- */
            if(evaluation.hasOwnProperty('answers') && evaluation.answers.comments !== '') {
                //Get the comments for the overall evaluation
                scoreRows['evaluation-total'][evaluatorId].comments = evaluation.answers.comments;
            }

            _.each(evaluationForm.questionGroups, function (questionGroup) {
                scoreRows[questionGroup.id][evaluatorId] = {
                    score: EMPTYSCORE,
                    comments: ''
                };

                // Recurse down to initialize question scores
                _.each(questionGroup.questions, function (question) {
                    scoreRows[question.id][evaluatorId] = {
                        score: EMPTYSCORE,
                        comments: ''
                    };
                });
            });

            if (evaluation.status === qualityManagementService.FINISHED && evaluation.answers) {

                // Fill in the score rows for the evaluation grid.
                var totalScoreString = ko.i18n.format( evaluation.answers.totalScore / 100, 'p');

                scoreRows['evaluation-total'][evaluatorId].score = totalScoreString;

                _.each(evaluation.answers.questionGroupScores, function (questionGroupScore) {
                    if (questionGroupScore.markedNA) {
                        scoreRows[questionGroupScore.questionGroupId][evaluatorId].score = ko.i18n.renderString("playback.calibrationSummary.score.na");
                    } else if (questionGroupScore.totalScore !== undefined) {
                        scoreRows[questionGroupScore.questionGroupId][evaluatorId].score = questionGroupScore.totalScore.toString();
                    }

                    // Fill in the score rows for each of the question group grids.
                    _.each(questionGroupScore.questionScores, function (questionScore) {
                        if (questionScore.markedNA || questionGroupScore.markedNA) {
                            scoreRows[questionScore.questionId][evaluatorId].score = ko.i18n.renderString("playback.calibrationSummary.score.na");
                        } else if (questionScore.score !== undefined) {
                            scoreRows[questionScore.questionId][evaluatorId].score = questionScore.score.toString();
                        }
                        if(questionScore.hasOwnProperty('comments') && questionScore.comments !== ''){
                            scoreRows[questionScore.questionId][evaluatorId].comments = questionScore.comments;
                        }
                    });
                });
            }
        };

        var buildRows = function(keys, rows){
            var calibrationRows = [];
            _.each(rows, function(row){
                var newRow = {};
                _.each(keys, function(key){
                    if(row.hasOwnProperty(key)){
                        newRow[key] = row[key];
                        newRow.rowStyle = row.style;
                        if(row.comments){
                            newRow.comments = row.comments;
                        }
                    } else {
                        newRow[key] = EMPTYSCORE;
                    }
                });
                calibrationRows.push(newRow);
            });
            return calibrationRows;
        };

        var getEvaluationHref = function(evaluation) {
            return '#admin/interactions/' + evaluation.conversation.id + '/evaluations/' + evaluation.id;
        };

        var createCellTemplate = function (id, href){
            return '<a data-evaluator-id="'+ id +'" href="'+ href +'" data-bind="text: $data[\''+ id + '\'].score"></a>' +
                '<div class="calibration-evaluation-comments" data-bind="if: $data[\''+ id + '\'].comments"><i class="fa fa-comments" data-bind="tooltip:$data[\''+ id + '\'].comments"></i></div>';

        };

        var buildCalibrationGridData = function(calibration) {
            var unwrappedCalibration = ko.toJS(calibration);
            if (unwrappedCalibration.evaluationForm) {
                self.evaluationFormName(unwrappedCalibration.evaluationForm.name);
                self.highScore(unwrappedCalibration.highScore);
                self.lowScore(unwrappedCalibration.lowScore);
                self.averageScore(unwrappedCalibration.averageScore);
                self.variance(self.highScore() - self.lowScore());
                var evaluatorColumns;
                var evaluatorsToSort = unwrappedCalibration.evaluators;
                var expertEvaluator;
                var columns;

                self.calibrationResultsGrid({
                    columns: ko.observableArray([]),
                    rows: ko.observableArray([])
                });

                try {
                    if(unwrappedCalibration.expertEvaluator) {
                        expertEvaluator = _.find(unwrappedCalibration.evaluators, function(evaluator) {
                            return unwrappedCalibration.expertEvaluator.id === evaluator.id;
                        });
                        evaluatorsToSort = _.reject(unwrappedCalibration.evaluators, function(evaluator) {
                            return unwrappedCalibration.expertEvaluator && unwrappedCalibration.expertEvaluator.id === evaluator.id;
                        });
                    }

                    /* -- Create the columns for dataTable -- */
                    evaluatorColumns = _.map(_.sortBy(evaluatorsToSort, 'name'), function (evaluator) {
                        var evaluatorEvaluation = _.find(calibration.evaluations(), function(evaluation){
                            return evaluation.evaluator.id === evaluator.id;
                        });
                        evaluationHref = getEvaluationHref(evaluatorEvaluation);
                        var evaluatorId = evaluator.id;
                        return {
                            label: evaluator.name,
                            id: evaluatorId,
                            class: 'evaluator-column',
                            text: true,
                            cellTemplate: createCellTemplate(evaluatorId, evaluationHref)
                        };
                    });

                    if (expertEvaluator) {
                        var expertEvaluatorId = expertEvaluator.id;
                        var evaluatorEvaluation = _.find(calibration.evaluations(), function(evaluation){
                            return evaluation.evaluator.id === expertEvaluator.id;
                        });
                        evaluationHref = getEvaluationHref(evaluatorEvaluation);
                        var columnText = ko.i18n.renderString('calibrationResults.columnName.expertEvaluator', { name: expertEvaluator.name });
                        evaluatorColumns.unshift({
                            label: columnText,
                            id: expertEvaluatorId,
                            class: 'evaluator-column',
                            text: true,
                            cellTemplate: createCellTemplate(expertEvaluatorId, evaluationHref)
                        });
                    } else if(unwrappedCalibration.scoringIndex) {
                        var scoringIndexId = unwrappedCalibration.scoringIndex.id;
                        var scoringIndexHref = getEvaluationHref(unwrappedCalibration.scoringIndex);
                        evaluatorColumns.unshift({
                            label: 'calibrationResults.columnName.scoringIndex',
                            id: scoringIndexId,
                            class: 'calibration-scoring-index',
                            cellTemplate: createCellTemplate(scoringIndexId, scoringIndexHref)
                        });
                    }

                    columns = ([{
                        label: 'calibrationResults.columnName.questionGroup',
                        id: 'questionGroup',
                        class: 'calibration-question-group',
                        cellTemplate: '<span data-bind="text: questionGroup"></span>'
                    }].concat(evaluatorColumns));

                    self.calibrationResultsGrid().columns(columns);
                    /* --  End creation of dataTable columns-- */

                    // scoreRows is a map with questionGroup/question ids as keys
                    // The values of scoreRows is a map of evaluatorIds to scores.
                    // This is used to populate all of the grids in this viewModel.
                    var scoreRows = {};

                    // Initialize total score
                    if (_.isUndefined(scoreRows['evaluation-total'])) {
                        scoreRows['evaluation-total'] = {
                            'questionGroup': ko.i18n.renderString('calibrationResults.rowName.evaluationFormTotal')
                        };
                    }

                    // Initialize question group scores
                    _.each(unwrappedCalibration.evaluationForm.questionGroups, function (questionGroup) {
                        if (_.isUndefined(scoreRows[questionGroup.id])) {
                            scoreRows[questionGroup.id] = {
                                'questionGroup': questionGroup.name,
                                'style': 'question-group-row'
                            };
                        }

                        // Recurse down to initialize question scores
                        _.each(questionGroup.questions, function (question) {
                            if (_.isUndefined(scoreRows[question.id])) {
                                scoreRows[question.id] = {
                                    'questionGroup': question.text,
                                    'questionGroupId': questionGroup.id,
                                    'style': 'question-row'
                                };
                            }
                        });
                    });

                    // Get the data for the grid
                    _.each(unwrappedCalibration.evaluations, function (evaluation) {
                        var evaluatorId = evaluation.evaluator.id;
                        aggregateEvaluationData(unwrappedCalibration.evaluationForm, scoreRows, evaluation, evaluatorId);
                    });

                    if (unwrappedCalibration.scoringIndex) {
                        aggregateEvaluationData(unwrappedCalibration.evaluationForm,
                            scoreRows,
                            unwrappedCalibration.scoringIndex,
                            unwrappedCalibration.scoringIndex.id);
                    }

                    var evaluationGridData = _.transform(unwrappedCalibration.evaluationForm.questionGroups, function (result, questionGroup) {
                        var questionGroupGridData = _.map(questionGroup.questions, function (question) {
                            return scoreRows[question.id];
                        });
                        questionGroupGridData.unshift(scoreRows[questionGroup.id]);
                        return result.concat(questionGroupGridData);
                    }, []);

                    // Create the column keys so rows can be built
                    var columnKeys = [];
                    _.each(columns, function(column){
                        columnKeys.push(column.id);
                    });

                    evaluationGridData.unshift(scoreRows['evaluation-total']);

                    var calibrationGridData = buildRows(columnKeys, scoreRows);

                    self.calibrationResultsGrid().rows(calibrationGridData);
                }
                catch (e) {
                    toasts.notifyCriticalAlert('playback.calibrationSummary.fail.msg');
                }

            }
        };

        self.subscribe(self.calibration, function (newCalibration) {
            buildCalibrationGridData(newCalibration);
            self.editCalibrationView(self.subView(EditCalibrationView, self.calibration));
        });

        var getCalibration = function () {
            self.isLoading(true);
            qualityManagementService.getCalibration(calibrationId, {calibratorId: authService.principalId()})
            .then(function (response) {
                self.calibration(new Calibration(response));
            })
            .catch(errorCallbackFactory.createCallback({ namespace: "calibrationResults.getCalibrationRequest"}))
            .finally(function () {
                self.isLoading(false);
            });
        };
        getCalibration();

    });
    return CalibrationResultsView;
});

